import { render, staticRenderFns } from "./MilkVatDetail.vue?vue&type=template&id=1311c225&"
import script from "./MilkVatDetail.vue?vue&type=script&lang=ts&"
export * from "./MilkVatDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports